import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Badge } from '@ionic-native/badge/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';

import { NoCacheHeadersInterceptor } from './interceptors/jwt.interceptor';

import { AppUpdate } from '@ionic-native/app-update/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { Drivers } from '@ionic/storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, IonicStorageModule.forRoot({
    name: 'eyeot',
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
  }),
  ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production, registrationStrategy: 'registerImmediately' }),
  BrowserAnimationsModule ],
  providers: [    
    Badge, 
    AppUpdate,   
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: HTTP_INTERCEPTORS, useClass: NoCacheHeadersInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {  
}
